const FormatLPID = (lpid: string): string => ((lpid.includes('-')) ? lpid : `${lpid.substring(0, 6)}-${lpid.substring(6, 10)}-${lpid.substring(10, 16)}`);
export default FormatLPID;
